export default __webpack_public_path__ + "static/33F324_6_0-a7beccb0a8a80439c6eec092d59ba843.woff";